(function (global) {
  'use strict';

  var ENTRY_KEY = 'hp-quiz-entry';
  var ENTRY_SEQ_KEY = 'hp-quiz-entry-seq';
  var EMAIL_KEY = 'kl_quiz_email';
  var ENTRY_MAX = 999999;
  var ENTRY_MIN = 1000;

  function normalizeEntry(value) {
    var num = parseInt(String(value || '').replace(/\D/g, ''), 10);
    if (isNaN(num) || num < 1) return '';
    if (num > ENTRY_MAX) num = ((num - 1) % ENTRY_MAX) + 1;
    return String(num);
  }

  function formatEntryDigits(value) {
    var digits = normalizeEntry(value);
    if (!digits) return '';
    return digits.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
  }

  function readSeq() {
    try {
      var seq = parseInt(localStorage.getItem(ENTRY_SEQ_KEY), 10);
      if (!isNaN(seq) && seq >= ENTRY_MIN && seq <= ENTRY_MAX) return seq;
    } catch (e) {}
    return ENTRY_MIN + Math.floor(Math.random() * 48000);
  }

  function writeSeq(seq) {
    try {
      localStorage.setItem(ENTRY_SEQ_KEY, String(seq));
    } catch (e) {}
  }

  function generateEntryNumber() {
    var seq = readSeq() + 1;
    if (seq > ENTRY_MAX) seq = ENTRY_MIN;
    writeSeq(seq);
    return String(seq);
  }

  function getEntry() {
    try {
      var raw = sessionStorage.getItem(ENTRY_KEY) || localStorage.getItem(ENTRY_KEY) || '';
      return normalizeEntry(raw);
    } catch (e) {
      return '';
    }
  }

  function setEntry(value) {
    var entry = normalizeEntry(value);
    if (!entry) return;
    try {
      sessionStorage.setItem(ENTRY_KEY, entry);
      localStorage.setItem(ENTRY_KEY, entry);
      var num = parseInt(entry, 10);
      if (!isNaN(num)) writeSeq(Math.max(readSeq(), num));
    } catch (e) {}
  }

  function assignEntry(forceNew) {
    if (!forceNew) {
      var existing = getEntry();
      if (existing) return existing;
    }
    var entry = generateEntryNumber();
    setEntry(entry);
    return entry;
  }

  function getEmail() {
    try {
      return sessionStorage.getItem(EMAIL_KEY) || localStorage.getItem(EMAIL_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function setEmail(value) {
    var email = String(value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
    try {
      sessionStorage.setItem(EMAIL_KEY, email);
      localStorage.setItem(EMAIL_KEY, email);
    } catch (e) {}
  }

  global.HpEntryStorage = {
    ENTRY_MAX: ENTRY_MAX,
    normalizeEntry: normalizeEntry,
    formatEntryDigits: formatEntryDigits,
    generateEntryNumber: generateEntryNumber,
    getEntry: getEntry,
    setEntry: setEntry,
    assignEntry: assignEntry,
    getEmail: getEmail,
    setEmail: setEmail
  };
})(window);
